import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import messages from '../../../locale/messages';
import { googleApiLoader } from '../../../helpers/googleApiLoader';
import debounce from '../../../helpers/debounce';
import { googleMapAPI, placeDetailURL, autoCompleteURL } from '../../../config';
import cx from 'classnames';
class PlacesSuggest extends Component {

  constructor(props) {
    super(props);
    this.state = {
      noResult: false,
      noInput: false,
      googleMapsApiLoaded: false,
      value: props.defaultValue || null,
      suggestion: []
    };
    this.dropdownRef = createRef();
  };

  async componentDidMount() {
    await googleApiLoader('places');
    this.setState({ googleMapsApiLoaded: true });
    const isDocument = typeof document !== undefined;
    if (isDocument) {
      document.addEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('touchstart', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    const isDocument = typeof document !== undefined;
    if (isDocument) {
      document.addEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('touchstart', this.handleClickOutside);
    }
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef?.current && !this.dropdownRef?.current?.contains(event?.target)) {
      this.setState({ suggestion: [] });
      const parentSection = document.getElementById('safariFailureGeoSuggestionDropDown');
      const childSection = document.getElementById('suggestItem');
      if (parentSection && childSection) {
        parentSection.removeChild(childSection);
      }
    }
  }

  handleBlur = async (input) => {
    this.setState({ noInput: !input })
  }

  handleAutoComplete = debounce(async (value) => {
    const { onChange } = this.props;
    onChange && onChange(value);
    if (value?.length > 0) {
      const requestData = { input: value };
      axios.post(
        autoCompleteURL,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': googleMapAPI
          }
        }
      ).then(response => {
        console.log('Response:', response.data);
        if (response?.data?.suggestions?.length > 0) {
          this.setState({ suggestion: response?.data?.suggestions, noResult: false });
        } else {
          this.setState({ noResult: true });
        }
      }).catch(error => {
        console.error('Error:', error?.response ? error?.response?.data : error?.message);
      });
    }
  }, 100)

  handleSuggest = async ({ placeId, value }) => {
    const { handleData } = this.props;
    if (placeId) {
      try {
        const response = await axios.get(`${placeDetailURL}${placeId}`, {
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': googleMapAPI,
            'X-Goog-FieldMask': '*'
          }
        });
        if (response?.data) {
          handleData(response?.data, value);
          this.setState({ value, suggestion: [], noResult: false });
        }
      } catch (error) {
        console.error('Place Details Error:', error?.response?.data || error?.message);
      }
    }
  }

  handleGeoSuggestFailure = (e) => {
    const { formatMessage } = this.props.intl;
    const suggestionsContainer = document.getElementById('safariFailureGeoSuggestionDropDown');
    suggestionsContainer.style.display = "block";
    let suggestionItem = document.createElement("div");
    suggestionItem.id = 'suggestItem';
    suggestionItem.classList.add('suggestItem')
    suggestionItem.textContent = formatMessage(messages.locationWarning);
    if (e.target.value != "") {
      if (!document.getElementById('suggestItem')) {
        suggestionsContainer.appendChild(suggestionItem);
      }
    } else {
      const parentSection = document.getElementById('safariFailureGeoSuggestionDropDown');
      const childSection = document.getElementById('suggestItem');
      if (parentSection && childSection) {
        parentSection.removeChild(childSection);
      }
    }
  }

  render() {
    const { label, className, containerClassName, form } = this.props;
    const { formatMessage } = this.props.intl;
    const { googleMapsApiLoaded, value, suggestion, noResult, noInput, } = this.state;

    return (
      <div ref={this.dropdownRef}>
        {
          googleMapsApiLoaded ?
            <div className='customGeoSuggestInputContainer'>
              <input
                type='text'
                className={cx('customGeoSuggestInput', className)}
                placeholder={label}
                value={value}
                autoComplete='off'
                onBlur={() => this.handleBlur(value)}
                onChange={(e) => {
                  this.setState({ value: e?.target?.value, noInput: !e?.target?.value });
                  if (e?.target?.value?.length == 0) this.setState({ suggestion: [] });
                  this.handleAutoComplete(e?.target?.value)
                }}
              />
              {
                suggestion?.length > 0 && (
                  <ul className='customGeoSuggestInputListContainer'>
                    {
                      suggestion?.map((item, itemIndex) => {
                        return (
                          <li key={itemIndex} className='customGeoSuggestInputListItem'
                            onClick={() => this.handleSuggest({ placeId: item?.placePrediction?.placeId, value: item?.placePrediction?.text?.text })}
                          >
                            {item?.placePrediction?.text?.text}
                          </li>
                        )
                      })}
                  </ul>
                )
              }
            </div>
            :
            <div className='safariFailureInputWrapper'>
              <input
                type='text'
                className={cx('safariFailureGeoSuggestion', className)}
                placeholder={label}
                value={value}
                autoComplete='off'
                onChange={(e) => this.handleGeoSuggestFailure(e)}
              />
              <div id={'safariFailureGeoSuggestionDropDown'} className='failureDropDown' />
            </div>
        }

        {form == 'signup' ?
          noResult && <span className={cx('arrow_box')}>{formatMessage(messages.invalidAddress)}</span>
          :
          noResult && <span className={'placeError'}>{formatMessage(messages.invalidAddress)}</span>
        }

        {form == 'signup' ?
          noInput && <span className={cx('arrow_box')}>{formatMessage(messages.required)}</span>
          :
          noInput && <span className={'placeError'}>{formatMessage(messages.required)}</span>
        }
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  change
};

export default injectIntl((connect(mapStateToProps, mapDispatchToProps)(PlacesSuggest)));
